import { combineReducers } from 'redux'
import todoSlice from '@/redux/reducers/todoReducer'
import ListGameSlice from './gameReducer'
import ListUserSlice from './userReducer'
import ListErrorHandler from './errorHandlerReducer'
import RouterSlice from './routerReducer'
import YeekeeGameSlice from './yeekeeReducer'
import limitNumberSlice from './limitNumberReducer'
import viewTicketSlice from './viewTicketReducer'

const rootReducer = combineReducers({
  todo: todoSlice.reducer,
  games: ListGameSlice.reducer,
  user: ListUserSlice.reducer,
  error: ListErrorHandler.reducer,
  router: RouterSlice.reducer,
  yeekee: YeekeeGameSlice.reducer,
  limitTemplate: limitNumberSlice.reducer,
  viewTicket: viewTicketSlice.reducer,
})

type AllSlices = [
  typeof todoSlice,
  typeof ListGameSlice,
  typeof ListUserSlice,
  typeof ListErrorHandler,
  typeof RouterSlice,
  typeof YeekeeGameSlice,
  typeof limitNumberSlice,
  typeof viewTicketSlice,
]

// Utility type: given a slice, extract the union of all action creators
type ActionsOf<T> = T extends { actions: infer A } ? A[keyof A] : never

// Use ActionsOf on each slice by indexing the tuple with [number]
// This produces a union of all slice actions.
export type RootActions = ReturnType<ActionsOf<AllSlices[number]>>

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
